import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-grey mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_colored_select = _resolveComponent("ontos-colored-select")!
  const _component_ontos_person_line = _resolveComponent("ontos-person-line")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, {
              title: _ctx.$tt('invitations'),
              level: 1
            }, null, 8, ["title"]),
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: account.user
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ontos_person_line, {
                        user: account.user,
                        email: account.email,
                        name: account.name,
                        photo: account.photo
                      }, {
                        default: _withCtx(() => [
                          (_ctx.locked(account))
                            ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                                key: 0,
                                option: _ctx.accessOption(account.access),
                                form: "chip"
                              }, null, 8, ["option"]))
                            : (_openBlock(), _createBlock(_component_ontos_colored_select, {
                                key: 1,
                                "model-value": account.access,
                                items: _ctx.levels,
                                variant: "plain",
                                class: "access-select",
                                "onUpdate:modelValue": ($event: any) => (_ctx.change(account, $event))
                              }, null, 8, ["model-value", "items", "onUpdate:modelValue"]))
                        ]),
                        _: 2
                      }, 1032, ["user", "email", "name", "photo"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            (_ctx.onlyApprover)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$tt('last-approver-note')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}